export default __webpack_public_path__ + "static/137-f783c0979a487444d97d2b6d49f7b7b2.jpg";